export const UPDATE_USER = 'UPDATE_USER'

export const updateUserName = text => ({
  type: UPDATE_USER,
  firstname: text,
  lastname: text
})
